module.exports = __webpack_public_path__ + "static/media/mobile1.1241f382.png";